// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const autocompleteFontStyles = () => css`
    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.base /* Store Custom Code */};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const autocompleteLinkWithImageStyles = () => css`
    display: flex;
    align-items: center;
    gap: ${pxToRem(10)};
`;
